import { handleAdminQuantityDefinitionUpdated } from "./admin";
import { handleUserQuantityDefinitionUpdated } from "./user";

export function handleQuantityDefintionUpdated(state, patch) {

    // console.log('handleQuantityDefintionUpdated: ', patch)
    const { visibility, payload } = patch;
    if (patch.visibility === "admin") {
        return handleAdminQuantityDefinitionUpdated(state, payload);
    }

    return handleUserQuantityDefinitionUpdated(state, payload);
}